import { InterestedParty } from './interested-party';

export class Estate {
  probateStatus?: 'granted' | 'pending' | 'unnecessary' | 'uncertain';
  isEstateWindup?: boolean;
  isInsuranceClaim?: boolean;
  insuranceClaimant?: 'owner' | 'beneficiary' | 'estate';
  interestedParties?: InterestedParty[];
}
